module.exports = __webpack_public_path__ + "static/img/fa1.df475c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/solution/fa1.png
// module id = CzT8
// module chunks = 3